export default function CTA() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative py-16 sm:py-24 lg:py-32 px-4 sm:px-8 overflow-hidden bg-gradient-to-br from-[#6B4423] via-[#5a3a1f] to-[#4A2F1A]">
      <div className="max-w-[1400px] mx-auto text-center relative z-10">
        {/* Main Headline */}
        <h2
          className="text-[40px] sm:text-[64px] lg:text-[88px] font-black text-[#F7F7F7] leading-none mb-6 sm:mb-8"
          style={{ letterSpacing: '-1px' }}
        >
          READY TO FORGE
          <br />
          YOUR LEGACY?
        </h2>

        {/* Subheadline */}
        <p className="text-base sm:text-xl text-white/80 mb-8 sm:mb-12 max-w-2xl mx-auto px-4">
          Join warriors who value craftsmanship and preparedness
        </p>

        {/* CTA Button */}
        <button
          onClick={() => scrollToSection('products')}
          className="bg-[#1a1a1a] text-white px-10 sm:px-16 py-4 sm:py-5 rounded-full text-base sm:text-lg font-bold hover:scale-105 transition-all inline-flex items-center gap-3 hover:ring-4 hover:ring-[#8B6914] whitespace-nowrap cursor-pointer"
        >
          EXPLORE COLLECTION
          <i className="ri-arrow-right-line text-[#8B6914] text-xl"></i>
        </button>

        {/* Decorative Elements */}
        <div className="mt-12 sm:mt-20 flex justify-center items-center gap-6 sm:gap-12 opacity-40">
          <i className="ri-sword-line text-[#8B6914] text-3xl sm:text-6xl"></i>
          <i className="ri-shield-line text-[#8B6914] text-3xl sm:text-6xl"></i>
          <i className="ri-hammer-line text-[#8B6914] text-3xl sm:text-6xl"></i>
          <i className="ri-fire-line text-[#8B6914] text-3xl sm:text-6xl hidden sm:block"></i>
          <i className="ri-knife-line text-[#8B6914] text-3xl sm:text-6xl hidden sm:block"></i>
        </div>
      </div>

      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-10 left-10 text-[80px] sm:text-[200px] text-white font-black">DWW</div>
        <div className="absolute bottom-10 right-10 text-[80px] sm:text-[200px] text-white font-black">DWW</div>
      </div>
    </section>
  );
}
